import React, { useEffect, useMemo, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Auth from './../auth/Auth';
import Login from '../layout/Login';
import Landing from '../layout/Landing';
import Registration from '../layout/Registration';
import Profile from '../layout/Profile';
import NewsLetter from '../layout/NewsLetter';
import EventCreation from '../layout/EventCreation';
import EventListing from '../layout/EventListing';
import EventEdit from '../layout/EventEdit';
import Notification from '../layout/Notification';
import Gallery from '../layout/Gallery';
import Terms from '../layout/Terms';
import FAQs from '../layout/FAQs';
import GalleryImage from '../layout/GalleryImage';
import ProgramDetails from '../layout/ProgramDetails';
import UserGuide from '../layout/UserGuide';
import VideoGallery from '../layout/VideoGallery';
import DocumentGallery from '../layout/DocumentGallery';
import DocumentSingle from '../layout/DocumentSingle';
import VideoSingle from '../layout/VideoSingle';
import PurchaseRegistration from '../layout/PurchaseRegistration';
import CategoryList from '../layout/CategoryList';
import EnrollMember from '../layout/EnrollMember';
import CreatePromoCamoaning from '../layout/CreatePromoCamoaning';
import PrivateRoute from '../utils/PrivateRoute';
import PurchaeRegistrationDealer from '../layout/PurchaseRegistrationDealer';
import ContactUs from '../layout/ContactUs';
import PurchaseRegistrationListing from '../layout/PurchaseRegistrationListing';
import LeadRegistrionListing from '../layout/LeadRegistrionListing';
import ProductList from '../layout/ProductList';
import LeadRegistration from '../layout/LeadRegistration';
import NotFound404 from '../layout/NotFound404';
import ProductDetailsPage from '../layout/ProductDetailsPage';
import Wishlist from '../layout/Wishlist';
import Cart from '../layout/Cart';
import PlaceOrder from '../layout/PlaceOrder';
import PurchaseApproval from '../layout/PurchaseApproval';
import About from '../layout/About';
import AddressList from '../layout/AddressList';
import AddNewAddress from '../layout/AddNewAddress';
import EditAddress from '../layout/EditAddress';
import Delivery from '../layout/Delivery';
import HelpDesk from '../layout/HelpDesk';
import RaiseTicket from '../layout/RaiseTicket';
import HelpDeskReply from '../layout/HelpDeskReply';
import MyPointStatement from '../layout/MyPointStatement';
import PointsEarned from '../layout/PointsEarned';
import PointsSpent from '../layout/PointsSpent';
import ReedemablePoints from '../layout/ReedemablePoints';
import MemberApproval from '../layout/MemberApproval';
import HelpDeskDetails from '../layout/HelpDeskDetails';
import UnlockGiftVoucher from '../layout/UnlockGiftVoucher';
import AllEstimate from '../layout/AllEstimate';
import Task from '../layout/Task';
import MyOrders from '../layout/MyOrders';
import HierarchyEventList from '../layout/HierarchyEventList';
import HierarchyEventDetails from '../layout/HierarchyEventDetails';
import Performance from '../layout/Performance';
import LibraryUpload from '../layout/LibraryUpload';
import DocumentLibrary from '../layout/DocumentLibrary';
import OtherService from '../services/Other';
import { useDispatch, useSelector } from 'react-redux';
import { addUserTypeAction } from '../redux/slices/userTypeSlice';
import BasicRegistrationContractor from '../layout/BasicRegistrationContractor';
import BasicRegistrationDealer from '../layout/BasicRegistrationDealer';
import AllEstimates from '../layout/AllEstimates';
import MyService from '../layout/MyService';
import ServiceRegistration from '../layout/ServiceRegistration';
import InfluencerApproval from '../layout/InfluencerApproval';
import BasicProfileCheck from '../utils/BasicProfileCheck';
import ProtectedRoute from '../utils/ProtectedRoute';
import PointsEarnedDetails from '../layout/PointsEarnedDetails';
import KycApproval from './KycApproval';
import KycApprovalUpdate from './KycApprovalUpdate';
import MyContractor from '../layout/MyContractor';
import MyContractorDetails from '../layout/MyContractorDetails';
import NewSiteRegistration from '../layout/NewSiteRegistration';
import MemberPerformance from '../layout/MemberPerformance';
import BrandEnrollment from '../layout/BrandEnrollment';
import MySite from '../layout/MySite';
import SchemeList from '../layout/SchemeList';
import MyRedemption from '../layout/MyOrders';
import RedemptionBrochure from '../layout/RedemptionBrochure';
import ActivityList from '../layout/ActivityList';

import { Activity } from 'react-feather';
import MyOrdersNew from '../layout/MyOrdersNew';
import ReferralList from '../layout/ReferralList';
import MyConsent from '../layout/MyConsent';
import AddressApprovalListing from '../layout/AddressApprovalListing';
import AddressApproval from '../layout/AddressApproval';
import Selfie from '../layout/Selfie';
import SelfieApproval from '../layout/SelfieApproval';
import DynamicEKYC from '../layout/DynamicEKYC';
import Passport from '../layout/Passport';
import AddressApprovalBulk from '../layout/AddressApprovalBulk';
import AlliedProductRegistration from '../layout/AlliedProductRegistration';
import MyAlliedPurchase from '../layout/MyAlliedPurchase';
import PurchaseApprovalAllied from '../layout/PurchaseApprovalAllied';
import MySites from '../layout/MySites';
import PointStatementReport from '../layout/PointStatementReport';
import SaleDataReport from '../layout/SaleDataReport';

const AppRoutes = () => {
  const isBasicProfileDone = JSON.parse(localStorage.getItem('isBasicProfileDone'));
  const dispatch = useDispatch();
  const showUserType = useSelector(state => state.userTypeSlice.userTypeAction)
  const [persona, setPersona] = useState([]);
  const [userHierDescription, setUserHierDescription] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await OtherService.hierarchiesList();
        if (res.success) {
          let arr = [];
          res.response.hierarchiesDetails.forEach((item, key) => {
          arr.push({ id: item.description, title: item.description});
          });
          setPersona(arr);
          
          
          
          const determineUser = (arr.some(item => ['Contractor', 'Engineer', 'Architect', 'Interior Designer', 'TSE', 'Dealer', 'Retailer'].includes(item.id))) ?
            'Public User' :
            'Admin User';
           dispatch((addUserTypeAction({ userTypeActionUpdate: determineUser })));
         

        }
      } catch (error) {
        // Handle errors if any
        console.log("Error fetching data:");
      }
    };

    fetchData();
  }, []);
  

  function AdminElement({ children }) {
    if (showUserType == 'Admin User') {
      return <>{children}</>
    }
    else {
      return (
        <>
          You don't have access to the current page
        </>
      );
    }

  }

  // function PublicElement({ children }) {
  //   if (showUserType == 'Public User') {
  //     return <>{children}</>
  //   }
  //   else {
  //     return (
  //       <>
  //         You don't have access to the current page
  //       </>
  //     );
  //   }
  // }
  const influencers = useMemo(() => {
    return ['Contractor', 'Engineer', 'Interior Designer']
  }, []);
  const dealerRetailer = useMemo(() => {
    return ['Dealer', 'ARS', 'Retailer']
  }, []);

  return (
    <>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route element={<PrivateRoute />}>
          {/* <Route path="/landing" element={<PublicElement><Landing/></PublicElement>} /> */}
          <Route path="/landing" element={<BasicProfileCheck><Landing /></BasicProfileCheck>} />
          {/* <Route path="/landing" element={<Landing/>}/> */}
          {/* <Route path="/landing" element={<Landing />} /> */}
          <Route path="/profile" element={<BasicProfileCheck><Profile /></BasicProfileCheck>} />
          <Route path="/basic-registration" element={<ProtectedRoute
            condition={!isBasicProfileDone}
            redirectTo="/landing">

            <BasicRegistrationContractor />
          </ProtectedRoute>} />
          {/* <Route path="/basic-registration" element={<BasicRegistrationContractor />} /> */}
          {/* <Route path="/basic-registration-dealer" element={<BasicRegistrationDealer/>} /> */}
          <Route path="/newsletter" element={<BasicProfileCheck><NewsLetter /></BasicProfileCheck>} />
          {/* <Route path='/event-creation' element={<AdminElement><EventCreation /></AdminElement>} /> */}
          <Route path='/event-creation' element={<AdminElement><EventCreation/></AdminElement>}/> 
           <Route path='/event-list' element={<Auth authorizedPersonas={[...influencers, ...dealerRetailer]}><EventListing /></Auth>} />
          <Route path='/hierarchy-event-list' element={<BasicProfileCheck><HierarchyEventList /></BasicProfileCheck>} />
          <Route path='/event-edit/:eventId' element={<Auth authorizedPersonas={[...influencers]}><EventEdit /></Auth>} />
          <Route path='/member-performance' element={<BasicProfileCheck><MemberPerformance /></BasicProfileCheck>} />
          <Route path='/hierarchyEventList/:eventId' element={<BasicProfileCheck><HierarchyEventDetails /></BasicProfileCheck>} />
          {/* <Route path='/event-creation' element={<EventCreation />} /> */}
          <Route path='/notification' element={<BasicProfileCheck><Notification /></BasicProfileCheck>} />
          <Route path='/gallery' element={<BasicProfileCheck><Gallery /></BasicProfileCheck>} />
          <Route path='/gallery-pic/:contentId' element={<BasicProfileCheck><GalleryImage /></BasicProfileCheck>} />
          <Route path='/video-gallery' element={<BasicProfileCheck><VideoGallery /></BasicProfileCheck>} />
          <Route path='/video-gallery/:contentId' element={<BasicProfileCheck><VideoSingle /></BasicProfileCheck>} />
          <Route path='/document-gallery' element={<BasicProfileCheck><DocumentGallery /></BasicProfileCheck>} />
          <Route path='/document-gallery/:contentId' element={<BasicProfileCheck><DocumentSingle /></BasicProfileCheck>} />
          <Route path='/program-details' element={<BasicProfileCheck><ProgramDetails /></BasicProfileCheck>} />
          <Route path='/lead-registration' element={<BasicProfileCheck><LeadRegistration /></BasicProfileCheck>} />
          <Route path='/purchase-registration' element={<Auth authorizedPersonas={['Contractor']}><PurchaseRegistration /></Auth>} />
          <Route path='/purchase-registration-dealer' element={<Auth authorizedPersonas={['Dealer']}><PurchaeRegistrationDealer /></Auth>} />
          <Route path='/my-contractor' element={<MyContractor />} />
          <Route path='/my-contractor/:contractorId' element={<MyContractorDetails />} />
          <Route path='/user-guide' element={<BasicProfileCheck><UserGuide /></BasicProfileCheck>} />
          <Route path='/terms' element={<BasicProfileCheck><Terms /></BasicProfileCheck>} />
          <Route path='/about' element={<BasicProfileCheck><About /></BasicProfileCheck>} />
          <Route path='/faqs' element={<BasicProfileCheck><FAQs /></BasicProfileCheck>} />
          <Route path='/contact-us' element={<BasicProfileCheck><ContactUs /></BasicProfileCheck>} />
          <Route path='/rewards-category-list' element={<BasicProfileCheck><CategoryList /></BasicProfileCheck>} />
          <Route path='/rewards-category-list/:catgryId' element={<BasicProfileCheck><ProductList /></BasicProfileCheck>} />
          <Route path='/rewards-category-list/:product_id/:category_id' element={<BasicProfileCheck><ProductDetailsPage /></BasicProfileCheck>} name="Product Details Page" />
          <Route path='/enroll-member' element={<Auth authorizedPersonas={['TSE', 'Dealer']}><EnrollMember /></Auth>} />
          <Route path='/purchase-registration-list' element={<Auth authorizedPersonas={[...influencers, 'TSE']}><PurchaseRegistrationListing /></Auth>} />
          <Route path='/purchase-approval/:itemId' element={<Auth authorizedPersonas={['TSE']}><PurchaseApproval /></Auth>} />
          <Route path='/lead-registration-list' element={<BasicProfileCheck><LeadRegistrionListing /></BasicProfileCheck>} />
          <Route path='/wishlist' element={<BasicProfileCheck><Wishlist /></BasicProfileCheck>} />
          <Route path='/cart' element={<BasicProfileCheck><Cart /></BasicProfileCheck>} />
          <Route path='/address-list' element={<BasicProfileCheck><AddressList /></BasicProfileCheck>} />
          <Route path='/add-new-address' element={<BasicProfileCheck><AddNewAddress /></BasicProfileCheck>} />
          <Route path='/edit-address/:addressId' element={<BasicProfileCheck><EditAddress /></BasicProfileCheck>} />
          <Route path='/delivery/:addressId' element={<BasicProfileCheck><Delivery /></BasicProfileCheck>} />
          <Route path='/delivery/:addressId/place-order' element={<BasicProfileCheck><PlaceOrder /></BasicProfileCheck>} />
          <Route path='/helpdesk' element={<BasicProfileCheck><HelpDesk /></BasicProfileCheck>} />
          <Route path='/points-earned-details/:month/:year' element={<BasicProfileCheck><PointsEarnedDetails/></BasicProfileCheck>} />
          <Route path='/raise-ticket' element={<BasicProfileCheck><RaiseTicket /></BasicProfileCheck>} />
          <Route path='/help-desk-reply/:ticketId/:ticketNo' element={<BasicProfileCheck><HelpDeskReply /></BasicProfileCheck>} />
          <Route path='/my-point-statement' element={<BasicProfileCheck><MyPointStatement /></BasicProfileCheck>} />
          <Route path='/reedamable-all-point' element={<BasicProfileCheck><ReedemablePoints /></BasicProfileCheck>} />
          <Route path='/point-earned' element={<BasicProfileCheck><PointsEarned /></BasicProfileCheck>} />
          <Route path='/scheme-list' element={<Auth authorizedPersonas={[...dealerRetailer]}><SchemeList /></Auth>} />
          <Route path='/point-spent' element={<BasicProfileCheck><PointsSpent /></BasicProfileCheck>} />
          <Route path='/purchase-approval' element={<BasicProfileCheck><PurchaseApproval /></BasicProfileCheck>} />
          <Route path='/my-orders' element={<BasicProfileCheck><MyOrders /></BasicProfileCheck>} />
          {/* <Route path='/my-orders' element={<BasicProfileCheck><MyOrdersNew /></BasicProfileCheck>} /> */}

          {/* <Route path='/kyc-approval' element={<Auth authorizedPersonas={['TSE']}><KycApproval /></Auth>} /> */}
          <Route path='/kyc-approval-update/:kycId' element={<Auth authorizedPersonas={['TSE']}><KycApprovalUpdate /></Auth>} />
          <Route path='/libraryUpload' element={<BasicProfileCheck><LibraryUpload /></BasicProfileCheck>} />
          <Route path='/document-library' element={<BasicProfileCheck><DocumentLibrary /></BasicProfileCheck>} />
          <Route path='/my-task' element={<BasicProfileCheck><Task /></BasicProfileCheck>} />
          <Route path='/helpdesk-details/:ticketId/:ticketNo' element={<BasicProfileCheck><HelpDeskDetails /></BasicProfileCheck>} />
          <Route path='/unlock-giftvoucher' element={<BasicProfileCheck><UnlockGiftVoucher /></BasicProfileCheck>} />
          <Route path='/my-performance' element={<BasicProfileCheck><Performance /></BasicProfileCheck>} />
          <Route path='/all-estimate' element={<BasicProfileCheck><AllEstimate /></BasicProfileCheck>} />
          <Route path='/service-registration' element={<BasicProfileCheck><ServiceRegistration /></BasicProfileCheck>} />
          <Route path='/my-service' element={<Auth authorizedPersonas={[...influencers, 'TSE']}><BasicProfileCheck><MyService /></BasicProfileCheck></Auth>} />
          <Route path='/my-site' element={<Auth authorizedPersonas={['TSE']}><BasicProfileCheck><MySites /></BasicProfileCheck></Auth>} />

          <Route path='/new-site-registration' element={<BasicProfileCheck><NewSiteRegistration /></BasicProfileCheck>} />
          <Route path='/brand-enrollment' element={<BasicProfileCheck><BrandEnrollment /></BasicProfileCheck>} />
          <Route path='/new-site-registration-list' element={<Auth authorizedPersonas={[...influencers]}><BasicProfileCheck><MySite /></BasicProfileCheck></Auth>} />
          <Route path='/member-approval' element={<Auth authorizedPersonas={['TSE']}><InfluencerApproval /></Auth>} />
          <Route path='/my-redemption' element={<BasicProfileCheck><MyOrders /></BasicProfileCheck>} />
          <Route path='/redemption-catalogue' element={<BasicProfileCheck><RedemptionBrochure /></BasicProfileCheck>} />
          <Route path='/rewards-catalogue' element={<BasicProfileCheck><CategoryList /></BasicProfileCheck>} />
          <Route path='/activity-list' element={<BasicProfileCheck><ActivityList /></BasicProfileCheck>} />
          <Route path='/referral-list' element={<BasicProfileCheck><ReferralList /></BasicProfileCheck>} />
          <Route path='/my-consent' element={<BasicProfileCheck><MyConsent /></BasicProfileCheck>} />

          <Route path='/address-approval-list' element={<BasicProfileCheck><AddressApprovalListing /></BasicProfileCheck>} />
          <Route path='/address-approval/:itemId' element={<Auth authorizedPersonas={['TSE']}><AddressApproval /></Auth>} />
          <Route path='/selfie' element={<BasicProfileCheck><Selfie /></BasicProfileCheck>} />
          <Route path='/selfie-approval' element={<Auth authorizedPersonas={['TSE']}><SelfieApproval /></Auth>} />
          <Route path='/dynamic-ekyc' element={<Auth authorizedPersonas={[...influencers, ...dealerRetailer]}><DynamicEKYC /></Auth>} />
          {/* <Route path='/passport' element={<Auth authorizedPersonas={[...influencers, ]}><Passport /></Auth>} /> */}
          <Route path='/address-approval-bulk' element={<Auth authorizedPersonas={['TSE']}><AddressApprovalBulk /></Auth>} />

          <Route path='/allied-product-registration' element={<Auth authorizedPersonas={[...influencers]}><AlliedProductRegistration /></Auth>} />
          <Route path='/allied-purchase-list' element={<Auth authorizedPersonas={['TSE', ...influencers]}><MyAlliedPurchase /></Auth>} />
          <Route path='/purchase-approval-allied/:itemId' element={<Auth authorizedPersonas={['TSE']}><PurchaseApprovalAllied /></Auth>} />
          <Route path='/my-point-statement-report' element={<BasicProfileCheck><PointStatementReport /></BasicProfileCheck>} />
          <Route path='/my-sale-data' element={<BasicProfileCheck><SaleDataReport /></BasicProfileCheck>} />

          <Route path="*" element={<NotFound404 />} />
        </Route>

      </Routes>

    </>
  );
}
export default AppRoutes